import React, { forwardRef } from "react";
import { Input } from "@mui/material";

const DSInput = forwardRef<
  HTMLInputElement,
  React.ComponentProps<typeof Input>
>((props, ref) => <Input ref={ref} {...props} />);

export default DSInput;
